module.exports = __webpack_public_path__ + "static/media/h2auto_logo.77fa6b46.svg";